import AttributeItem, { AttributeGrid } from 'dashboard/components/AttributeItem';
import { LinkifyExternal } from 'dashboard/components/LinkifyExternal';
import { ReportBusinessIndustryClassification } from 'dashboard/models/report/business-industry-classification';
import { ReportTemplate } from 'dashboard/models/report-template';

interface BusinessIndustryClassificationProps {
  report: ReportBusinessIndustryClassification;
  reportTemplate?: ReportTemplate;
  isRedacted: boolean;
}

export const BusinessIndustryClassification = ({
  report,
  isRedacted,
}: BusinessIndustryClassificationProps) => {
  const query = report.attributes?.query ?? { 'business-name': undefined, website: undefined };
  const { 'business-name': businessName, website: website } = query;

  return (
    <AttributeGrid>
      <AttributeItem
        title='Business name'
        value={businessName}
        placeholder='N/A'
        isRedacted={isRedacted}
      />
      <AttributeItem
        title='Website'
        value={<LinkifyExternal>{website}</LinkifyExternal>}
        placeholder='www.example.com'
        isRedacted={isRedacted}
      />
    </AttributeGrid>
  );
};
